import { history } from "app-history"

import { getProfile, getEducations, getExperiences, getReferences } from "api/@vp/passport"
import { getApplications, getApplicationFiles } from "api/@vp/applications"
import { getAssessmentContext, getAssessmentTemplate } from "api/@vp/assess"
import { getRegisterApplyJob, getMagicApplyJob } from "api/@vp/apply"

export const platformVpFetchProfile = () => {
  return async (dispatch) => {
    const data = await getProfile()
    if (!data.error) dispatch({ type: "VP_UPDATE_PROFILE", data })
  }
}

export const platformVpFetchEducations = () => {
  return async (dispatch) => {
    const data = await getEducations()
    if (!data.error) dispatch({ type: "VP_UPDATE_EDUCATIONS", data })
  }
}

export const platformVpFetchExperiences = () => {
  return async (dispatch) => {
    const data = await getExperiences()
    if (!data.error) dispatch({ type: "VP_UPDATE_EXPERIENCES", data })
  }
}

export const platformVpFetchReferences = () => {
  return async (dispatch) => {
    const data = await getReferences()
    if (!data.error) dispatch({ type: "VP_UPDATE_REFERENCES", data })
  }
}

export const platformVpFetchApplications = () => {
  return async (dispatch) => {
    const data = await getApplications()
    if (!data.error) dispatch({ type: "VP_UPDATE_APPLICATIONS", data })
  }
}

export const platformVpFetchAssessmentContext = (params) => {
  return async (dispatch) => {
    const data = await getAssessmentContext(params)
    if (!data.error) dispatch({ type: "VP_UPDATE_ASSESSMENT_CONTEXT", data })
    const querypath = history.location.pathname
    const arraypath = querypath.split('/')
    arraypath.shift();
    arraypath.shift();
    const redirectpath = arraypath.join('/')
    if (data.submitted) history.push(`/assess-success/${redirectpath}`)
  }
}

export const platformVpFetchTemplate = (relationship) => {
  return async (dispatch) => {
    const data = await getAssessmentTemplate(relationship)
    const { template } = data;
    if (!data.error) dispatch({ type: "VP_UPDATE_ASSESSMENT_TEMPLATE", data: template })
  }
}

export const platformVpFetchRegisterApplyJob = (params) => {
  return async (dispatch) => {
    const data = await getRegisterApplyJob(params)
    if (!data.error) dispatch({ type: "VP_UPDATE_JOB_APPLICATION", data })
  }
}

export const platformVpFetchMagicApplyJob = (params) => {
  return async (dispatch) => {
    const data = await getMagicApplyJob(params)
    if (!data.error) dispatch({ type: "VP_UPDATE_JOB_APPLICATION", data })
  }
}

export const platformVpFetchApplicationFiles = (params) => {
  return async (dispatch) => {
    const data = await getApplicationFiles(params)
    if (!data.error) dispatch({ type: "VP_UPDATE_APPLICATION_FILES", data })
  }
}

export const platformVpUpdateEngagement = (relationshipDuration, relationshipEngagement) => {
  const relationshipDurationRange = ['Under 3 months', '3-6 months', '6-12 months', '1-3 years', 'More than 3 years']
  const relationshipEngagementRange = ['Yearly', 'Quarterly', 'Monthly', 'Weekly', 'Daily']

  const durationMultiplier = relationshipDurationRange.indexOf(relationshipDuration) + 1
  const engagementMultiplier = relationshipEngagementRange.indexOf(relationshipEngagement) + 1

  const engagement = durationMultiplier * engagementMultiplier;

  let engagementLevel = 0;
  if (engagement <= 25) engagementLevel = 4
  if (engagement <= 20) engagementLevel = 3
  if (engagement <= 15) engagementLevel = 2
  if (engagement <= 10) engagementLevel = 1
  if (engagement <= 5) engagementLevel = 0

  return async (dispatch) => {
    dispatch({ type: "VP_UPDATE_REFEREE_ENGAGEMENT_LEVEL", data: engagementLevel })
  }
}
